import React, { useState } from "react";

const styles = {
  page: {
    background: "#000",
    color: "#fff",
    minHeight: "100vh",
    padding: "48px 24px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', sans-serif",
  },
  container: {
    maxWidth: "680px",
    margin: "0 auto",
  },
  header: {
    textAlign: "center",
    marginBottom: "48px",
  },
  badge: {
    display: "inline-block",
    background: "rgba(168,85,247,0.15)",
    border: "1px solid rgba(168,85,247,0.4)",
    color: "#c084fc",
    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    padding: "6px 14px",
    borderRadius: "100px",
    marginBottom: "20px",
  },
  h1: {
    fontSize: "36px",
    fontWeight: "700",
    letterSpacing: "-0.03em",
    color: "#fff",
    margin: "0 0 10px",
  },
  subtitle: {
    fontSize: "15px",
    color: "rgba(255,255,255,0.45)",
    fontWeight: "400",
    letterSpacing: "-0.01em",
    margin: 0,
  },
  divider: {
    border: "none",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    margin: "36px 0",
  },
  inputRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    marginBottom: "36px",
  },
  input: {
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "12px",
    padding: "14px 16px",
    color: "#fff",
    fontSize: "15px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    transition: "border-color 0.2s",
  },
  questionBlock: {
    marginBottom: "28px",
  },
  questionLabel: {
    fontSize: "17px",
    fontWeight: "600",
    letterSpacing: "-0.02em",
    color: "#fff",
    marginBottom: "12px",
    lineHeight: "1.4",
  },
  questionNumber: {
    color: "#a855f7",
    marginRight: "6px",
  },
  optionsRow: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  optionBtn: (active, color) => ({
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "13px 16px",
    borderRadius: "12px",
    border: active ? `1.5px solid ${color}` : "1px solid rgba(255,255,255,0.08)",
    background: active ? `${color}18` : "rgba(255,255,255,0.03)",
    color: active ? "#fff" : "rgba(255,255,255,0.65)",
    fontSize: "14px",
    fontWeight: active ? "500" : "400",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif",
    cursor: "pointer",
    textAlign: "left",
    transition: "all 0.15s ease",
    letterSpacing: "-0.01em",
  }),
  dot: (active, color) => ({
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: active ? color : "rgba(255,255,255,0.2)",
    flexShrink: 0,
    transition: "background 0.15s",
  }),
  submitBtn: {
    width: "100%",
    padding: "16px",
    background: "#a855f7",
    border: "none",
    borderRadius: "14px",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "600",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif",
    cursor: "pointer",
    letterSpacing: "-0.01em",
    marginTop: "8px",
    transition: "opacity 0.2s, transform 0.1s",
  },
  summaryCard: {
    marginTop: "36px",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "20px",
    padding: "32px",
  },
  summaryHeader: {
    fontSize: "13px",
    fontWeight: "600",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    color: "#fff",
    marginBottom: "20px",
  },
  summaryLeadName: {
    fontSize: "22px",
    fontWeight: "700",
    letterSpacing: "-0.03em",
    color: "#fff",
    margin: "0 0 4px",
  },
  summaryLeadEmail: {
    fontSize: "14px",
    color: "#fff",
    margin: "0 0 28px",
  },
  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "12px 0",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    gap: "16px",
  },
  summaryKey: {
    fontSize: "13px",
    color: "#fff",
    fontWeight: "500",
    flexShrink: 0,
    minWidth: "120px",
  },
  summaryVal: {
    fontSize: "13px",
    color: "#fff",
    fontWeight: "500",
    textAlign: "right",
  },
  verdictBox: (color) => ({
    marginTop: "24px",
    padding: "20px",
    background: `${color}15`,
    border: `1.5px solid ${color}50`,
    borderRadius: "14px",
    textAlign: "center",
  }),
  verdictText: (color) => ({
    fontSize: "15px",
    fontWeight: "700",
    color: color,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    margin: 0,
  }),
};

const questions = [
  {
    key: "q1",
    label: "How many trucks or teams do you currently operate?",
    options: [
      { val: "G", color: "#22c55e", text: "10+ Trucks / Multiple Teams" },
      { val: "Y", color: "#eab308", text: "4–10 Trucks" },
      { val: "R", color: "#a855f7", text: "1–3 Trucks / Small Operation" },
    ],
  },
  {
    key: "q2",
    label: "On average, how many jobs do you complete per week?",
    options: [
      { val: "G", color: "#22c55e", text: "50+ Jobs Per Week" },
      { val: "Y", color: "#eab308", text: "20–50 Jobs Per Week" },
      { val: "R", color: "#a855f7", text: "Less than 20 Jobs Per Week" },
    ],
  },
  {
    key: "q3",
    label: "What is your approximate monthly revenue range?",
    options: [
      { val: "G", color: "#22c55e", text: "$50K+ Monthly Revenue" },
      { val: "Y", color: "#eab308", text: "$15K – $50K Monthly Revenue" },
      { val: "R", color: "#a855f7", text: "Under $15K Monthly Revenue" },
    ],
  },
  {
    key: "q4",
    label: "What type of customers do you mainly work with?",
    options: [
      { val: "G", color: "#22c55e", text: "Commercial / Big Contracts" },
      { val: "Y", color: "#eab308", text: "Mix of Residential & Commercial" },
      { val: "R", color: "#a855f7", text: "Mostly Residential Jobs" },
    ],
  },
  {
    key: "q5",
    label: "What is your biggest challenge right now?",
    options: [
      { val: "G", color: "#22c55e", text: "Need High Quality / High Paying Leads" },
      { val: "Y", color: "#eab308", text: "Need More Consistent Lead Flow" },
      { val: "R", color: "#a855f7", text: "Not Getting Enough Jobs Overall" },
    ],
  },
  {
    key: "q6",
    label: "How consistent is your workload?",
    options: [
      { val: "G", color: "#22c55e", text: "Fully Booked Most Weeks" },
      { val: "Y", color: "#eab308", text: "Some Gaps in Schedule" },
      { val: "R", color: "#a855f7", text: "Very Inconsistent Work" },
    ],
  },
  {
    key: "q7",
    label: "How are you currently getting leads?",
    options: [
      { val: "G", color: "#22c55e", text: "Strong Multiple Lead Sources" },
      { val: "Y", color: "#eab308", text: "Some Lead Sources" },
      { val: "R", color: "#a855f7", text: "No Reliable Lead System" },
    ],
  },
  {
    key: "q8",
    label: "Are you the decision maker for marketing/services?",
    options: [
      { val: "G", color: "#22c55e", text: "Yes, I make all decisions" },
      { val: "Y", color: "#eab308", text: "I influence decisions" },
      { val: "R", color: "#a855f7", text: "Someone else decides" },
    ],
  },
  {
    key: "q9",
    label: "Have you used marketing or lead generation services before?",
    options: [
      { val: "G", color: "#22c55e", text: "Yes, multiple times" },
      { val: "Y", color: "#eab308", text: "Tried once or twice" },
      { val: "R", color: "#a855f7", text: "No, first time" },
    ],
  },
  {
    key: "q10",
    label: "How urgent is your need for more business?",
    options: [
      { val: "G", color: "#22c55e", text: "Very Urgent (Need Growth Now)" },
      { val: "Y", color: "#eab308", text: "Some Urgency (Planning Growth)" },
      { val: "R", color: "#a855f7", text: "No Urgency (Just Exploring)" },
    ],
  },
];

const summaryLabels = ["Trucks", "Jobs", "Revenue", "Customers", "Challenge", "Consistency", "Lead Sources", "Decision Maker", "Experience", "Urgency"];

export default function Segment() {
  const [lead, setLead] = useState({ name: "", email: "" });
  const [answers, setAnswers] = useState({ q1: "", q2: "", q3: "", q4: "", q5: "", q6: "", q7: "", q8: "", q9: "", q10: "" });
  const [summary, setSummary] = useState(null);

  const clickSound = () => {
    const audio = new Audio("/click.mp3");
    audio.play().catch(() => {});
  };

  const select = (key, value) => {
    setAnswers(prev => ({ ...prev, [key]: value }));
    clickSound();
  };

  const getAnswerText = (key, val) => {
    if (!val) return "Not Selected";
    const q = questions.find(q => q.key === key);
    const opt = q?.options.find(o => o.val === val);
    return opt?.text || "Not Selected";
  };

  const generateSummary = () => {
    const all = Object.values(answers);
    const green = all.filter(x => x === "G").length;
    const yellow = all.filter(x => x === "Y").length;

    const final =
      green >= 6
        ? { label: "High Value Lead — Strong Close Potential", color: "#22c55e" }
        : yellow >= 6 || green >= 4
        ? { label: "Growth Lead — Follow Up Required", color: "#eab308" }
        : { label: "Low Priority Lead — Nurture or Skip", color: "#a855f7" };

    setSummary({ lead, answers, final });
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>

        {/* Header */}
        <div style={styles.header}>
          <div style={styles.badge}>I Am The Closer</div>
          <h1 style={styles.h1}>Lead Segment System</h1>
          <p style={styles.subtitle}>Junk Removal · Live Call Qualifier</p>
        </div>

        {/* Lead Info */}
        <div style={styles.inputRow}>
          <input
            placeholder="Full Name"
            style={styles.input}
            onChange={(e) => setLead({ ...lead, name: e.target.value })}
          />
          <input
            placeholder="Email Address"
            style={styles.input}
            onChange={(e) => setLead({ ...lead, email: e.target.value })}
          />
        </div>

        <hr style={styles.divider} />

        {/* Questions */}
        {questions.map((q, i) => (
          <div key={q.key} style={styles.questionBlock}>
            <div style={styles.questionLabel}>
              <span style={styles.questionNumber}>{i + 1}.</span>
              {q.label}
            </div>
            <div style={styles.optionsRow}>
              {q.options.map(opt => (
                <button
                  key={opt.val}
                  onClick={() => select(q.key, opt.val)}
                  style={styles.optionBtn(answers[q.key] === opt.val, opt.color)}
                >
                  <span style={styles.dot(answers[q.key] === opt.val, opt.color)} />
                  {opt.text}
                </button>
              ))}
            </div>
          </div>
        ))}

        <hr style={styles.divider} />

        {/* Submit */}
        <button
          onClick={generateSummary}
          style={styles.submitBtn}
          onMouseOver={e => e.currentTarget.style.opacity = "0.85"}
          onMouseOut={e => e.currentTarget.style.opacity = "1"}
        >
          Get Full Call Summary
        </button>

        {/* Summary */}
        {summary && (
          <div style={styles.summaryCard}>
            <div style={styles.summaryHeader}>Lead Summary Report</div>

            <p style={styles.summaryLeadName}>{summary.lead.name || "—"}</p>
            <p style={styles.summaryLeadEmail}>{summary.lead.email || "—"}</p>

            {questions.map((q, i) => (
              <div key={q.key} style={styles.summaryRow}>
                <span style={styles.summaryKey}>{summaryLabels[i]}</span>
                <span style={styles.summaryVal}>{getAnswerText(q.key, summary.answers[q.key])}</span>
              </div>
            ))}

            <div style={styles.verdictBox(summary.final.color)}>
              <p style={styles.verdictText(summary.final.color)}>{summary.final.label}</p>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}